/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';

import { getBrand } from '../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import findURL from '../../gql/queries/findURL';
import isProductListingAd from '../isProductListingAd';
import useIsDisplayChannel from './useIsDisplayChannel';
import useIsPlaPage from './useIsPlaPage';

// note: returns true when the URL IS excluded (kept for parity with HeaderBannersList)
const urlIsNotExcluded = (bySpecificPath, currentURL) => {
    const pathList = bySpecificPath.filter((item) => item.indexOf('*') >= 0);
    let urlFound = false;
    pathList.forEach((path) => {
        const specificPath = path.split('*')?.[0];
        if (currentURL.indexOf(specificPath) >= 0) {
            urlFound = true;
        }
    });
    return urlFound;
};

// mirrors HeaderBannersList's pageIsNotExcluded/urlIsNotExcluded so both components stay in sync
const useBannerExclusions = () => {
    const location = useLocation();
    const brand = useSelector(getBrand);
    const FIND_URL_QUERY = findURL(brand.domain, location?.pathname);
    const { data } = useQuery(FIND_URL_QUERY);
    const pageType = data?.findURL?.type || 'notfound';
    const contentType = data?.findURL?.contentType || 'notfound';
    const isPlaPage = useIsPlaPage();
    const isDisplayChannel = useIsDisplayChannel();
    const isPlaPagesEnabled = isPlaPage || isDisplayChannel || isProductListingAd(location?.search);

    return (exclusions) => {
        let currentUrl = location?.pathname || '/';
        if (typeof window !== 'undefined') currentUrl = window.location.pathname || '/';

        if (exclusions?.byPageType?.includes('pla') && isPlaPagesEnabled) {
            return false;
        }
        if (exclusions?.byPageType?.includes('searchterm') && currentUrl?.includes('searchterm')) {
            return false;
        }
        if (!pageType || (pageType === 'notfound' && !currentUrl?.includes('searchterm'))
            || exclusions.byPageType.includes(pageType)
            || exclusions.byPageType.includes(contentType)
            || exclusions.bySpecificPath.includes(currentUrl)
            || urlIsNotExcluded(exclusions.bySpecificPath, currentUrl)
        ) {
            // we are showing banner according to adding the URL in cms
            if (exclusions.bySpecificPathInclusion.includes(currentUrl)) {
                return true;
            }
            if (exclusions?.byPageType?.includes(pageType) || exclusions?.byPageType?.includes(contentType)) {
                if (isPlaPagesEnabled) {
                    return true;
                }
                return false;
            }
            return false;
        }
        return true;
    };
};

export default useBannerExclusions;
